import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  background: #F0E5DE;
  margin: 0 -24px;
  border-top: 1px solid #E4D7CD;
  border-bottom: 1px solid #E4D7CD;
`